'use client'

import { useState, useEffect } from 'react';

const Footer = () => {

    const [currentYear, setCurrentYear] = useState(null);

    useEffect(() => {
        const year = new Date().getFullYear();
        setCurrentYear(year);
    }, []);

    return (
        <footer className="bg-blue-950 py-3 text-center w-full border-t border-blue-900/50">
            <div className="max-w-4xl mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-1 md:gap-4 text-xs">
                <p className="text-blue-500">
                    <span role="img" aria-label="heart">Hecho con 💙 por </span>{" "}
                    <a
                        href="https://github.com/erasmoh"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-400 hover:text-white transition-colors"
                    >
                        Erasmo Hernández
                    </a>
                </p>
                <p className="text-blue-500">
                    <span className="hidden md:inline">• </span>
                    Datos:{" "}
                    <a
                        href="https://mindicador.cl"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-400 hover:text-blue-300 transition-colors"
                    >
                        mindicador.cl
                    </a>
                </p>
            </div>
        </footer>
    );
}

export default Footer;